import { Component } from "@angular/core";
import { MdDialog, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { SCALOperations, SCALType } from "../../interfaces/LicenseModel";
import { GenerateSCAL30LicenseComponent } from "./generate-scal360-license/generate-scal360-license.component";
import { ActivateScal360LicenseComponent } from "./activate-scal360-license/activate-scal360-license.component";
import { ViewScal360PurchaseHistoryComponent } from "./view-scal360-purchase-history/view-scal360-purchase-history.component";
import { RenewScal360LicenseComponent } from "./renew-scal360-license/renew-scal360-license.component";
import { ViewScal360LicenseInformationComponent } from "./view-scal360-license-information/view-scal360-license-information.component";
import { ViewScal360ActivationHistoryComponent } from "./view-scal360-activation-history/view-scal360-activation-history.component";
import { ViewScal360RenewalHistoryComponent } from "./view-scal360-renewal-history/view-scal360-renewal-history.component";
import { ViewScal360DownloadReleaseHistoryComponent } from "./view-scal360-download-release-history/view-scal360-download-release-history.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { Scal360FilterPipe } from "./pipes/scal360FilterPipe";
import { FilterPipe } from "../../pipes";

@Component({
    selector: 'license-scal360',
    template: require('./scal360.component.html'),
    styles: [require('./scal360.component.css')],
})
export class LicenseModuleScal360Component {
    SCALTypeEnum = SCALType;
    filterBillToName = '';
    filterShipToName = '';
    filterLicenseKey = '';
    filterSCALType = '';
    searchBillToName = '';
    searchShipToName = '';
    searchLicenseKey = '';
    searchSCALType = '';
    BillToList = [];
    ShipToList = [];
    scal360LicenseList = [];
    originalScal360LicenseList = [];
    filteredScal360LicenseList = [];
    errorMessage = '';
    SCALTypeList = [];
    expandedRow = null;
    isLoading = false;
    customerLicenseDetails = [];
    pager: any = {};
    pagedItems = [];
    IsAddEdit;
    IsDelete;
    ProductId;
    currentSortColumn;
    currentSortOrder;
    constructor(
        private dialog: MdDialog,
        private licenseService: LicenseService,
        private appLoader: AppLoaderService,
        private snackBar: MdSnackBar,
        private adalService: AdalService,
        private router: Router,
        private exportService: ExportToCSVService,
        private route: ActivatedRoute,
        private pagerService: PagerService,
        private userService: UserService,
        private filterPipe: Scal360FilterPipe
    ) {
        if (!this.adalService.getCachedToken()) {
            setTimeout(() => {
                this.router.navigate(["login"]);
            }, 100);
        }

        appLoader.close();
        route.params.subscribe((params) => {
            this.ProductId = params['productId']
        })
        this.getUserRights();
        this.getScalPurchaseLicenseDisplayDetails();
        Object.keys(SCALType).filter((type) => isNaN(Number(type))).forEach((key, index) => {
            this.SCALTypeList.push({
                name: key,
                value: SCALType[key]
            })
        })
    }

    getUserRights() {
        let UserId = Number(localStorage.getItem('userid'))
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
                this.IsAddEdit = data.DataObject.IsAddEdit;
                this.IsDelete = data.DataObject.IsDelete;
            }
        })
    }
    expandRow(index, row) {
        this.isLoading = true;
        this.expandedRow = this.expandedRow === index ? null : index;
        if (this.expandedRow != null) {
            this.customerLicenseDetails = [];
            this.licenseService.getScalCustomerLicenseDetailForActivationAndRenewal(row.LicenseId).subscribe((data) => {
                if (!data.IsError && data.DataObject != null) {
                    this.customerLicenseDetails = data.DataObject
                }
                else {

                }
                this.isLoading = false;
            })
        }
    }
    openGenerateNewLicenseRequestDialog() {
        let generateNewLicenseRequestDialogRef: MdDialogRef<GenerateSCAL30LicenseComponent> = this.dialog.open(GenerateSCAL30LicenseComponent, {
            width: '60%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: null,
                scalOperation: SCALOperations['add']
            },
            disableClose: true
        });
        generateNewLicenseRequestDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
            this.expandedRow = null;
            this.setPage(1);
        })

    }
    editLicenseRequestDialog(row) {
        let editLicenseRequestDialogRef: MdDialogRef<GenerateSCAL30LicenseComponent> = this.dialog.open(GenerateSCAL30LicenseComponent, {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
                scalOperation: SCALOperations['edit']
            },
            disableClose: true
        })
        editLicenseRequestDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
            this.expandedRow = null;
            this.setPage(this.pager.currentPage);
        })
    }
    addMoreLicenseRequestDialog(row) {
        let addMoreLicenseRequestDialogRef: MdDialogRef<GenerateSCAL30LicenseComponent> = this.dialog.open(GenerateSCAL30LicenseComponent, {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
                scalOperation: SCALOperations['addMore']
            },
            disableClose: true
        })
        addMoreLicenseRequestDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
            this.expandedRow = null;
            this.setPage(this.pager.currentPage);
        })
    }
    renewScalLicense(row) {
        let renewScalLicenseDialogRef: MdDialogRef<RenewScal360LicenseComponent> = this.dialog.open(RenewScal360LicenseComponent, {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
            },
            disableClose: true
        })
        renewScalLicenseDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
            this.expandedRow = null;
            this.setPage(this.pager.currentPage);
        })
    }
    viewScal360LicenseInformation(row) {
        let viewScalLicenseInformationDialogRef: MdDialogRef<ViewScal360LicenseInformationComponent> = this.dialog.open(ViewScal360LicenseInformationComponent, {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
            },
            disableClose: true
        })
        viewScalLicenseInformationDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
        })
    }
    viewScal360PurchaseHistory(row) {
        let viewScal360PurchaseHistoryDialogRef: MdDialogRef<ViewScal360PurchaseHistoryComponent> = this.dialog.open(ViewScal360PurchaseHistoryComponent, {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
            },
            disableClose: true
        })
        viewScal360PurchaseHistoryDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
        })
    }
    activateScalLicense(row) {
        let activateLicenseDialogRef: MdDialogRef<ActivateScal360LicenseComponent> = this.dialog.open(ActivateScal360LicenseComponent, {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        })
        activateLicenseDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
            this.setPage(this.pager.currentPage);
            this.expandedRow = null;
        })
    }
    viewScalActivationHistory(row) {
        let activationHistoryDialogRef: MdDialogRef<ViewScal360ActivationHistoryComponent> = this.dialog.open(ViewScal360ActivationHistoryComponent, {
            width: '40%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        })
        activationHistoryDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
            this.setPage(this.pager.currentPage);
            console.log(this.scal360LicenseList)
        })
    }
    viewScalRenewalHistory(row) {
        let renewalHistoryDialogRef: MdDialogRef<ViewScal360RenewalHistoryComponent> = this.dialog.open(ViewScal360RenewalHistoryComponent, {
            width: '40%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        })
        renewalHistoryDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
        })
    }
    viewScalDownloadReleaseHistory(row) {
        let scalDownloadReleaseHistoryDialogRef: MdDialogRef<ViewScal360DownloadReleaseHistoryComponent> = this.dialog.open(ViewScal360DownloadReleaseHistoryComponent, {
            width: '40%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        })
        scalDownloadReleaseHistoryDialogRef.afterClosed().subscribe((result) => {
            this.originalScal360LicenseList = result;
            this.scal360LicenseList = [...this.originalScal360LicenseList];
        })
    }
    deleteCustomerLicense(row) {
        Swal.fire({
            title: 'Delete License',
            text: 'Are you sure you want to delete the license?',
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                let model = {
                    LicenseId: row.LicenseId,
                    UpdatedBy: Number(localStorage.getItem('userid'))
                }
                this.appLoader.open()
                this.licenseService.deleteScalCustomerLicense(model).subscribe((data) => {
                    if (!data.IsError && data.DataObject != null) {
                        this.originalScal360LicenseList = data.DataObject;
                        this.scal360LicenseList = [...this.originalScal360LicenseList];
                        this.setPage(this.pager.currentPage);
                        this.appLoader.close()
                    }
                    
                    this.appLoader.close()
                })
            }
        })
    }

  deleteParticularLicenseKey(row,mainlicense,mainlicensedetails) {    
    if (mainlicensedetails.length== 1) {
     Swal.fire({
      title: "Delete License",
      text: "Are you sure you want to delete this license? This action will permanently remove all license information associated with the customer.",
      showCancelButton: true,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonColor: "#FFCA28",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        let model = {
          LicenseId: mainlicense.LicenseId,
          UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.appLoader.open();
        this.licenseService
          .deleteScalCustomerLicense(model)
          .subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
              this.originalScal360LicenseList = data.DataObject;
              this.scal360LicenseList = [...this.originalScal360LicenseList];
              this.expandedRow=null;
              this.setPage(this.pager.currentPage);
              this.appLoader.close();
            }            
          });
      }
    });
    } else {
      Swal.fire({
        title: "Delete License",
        text: "Are you sure you want to delete the license?",
        showCancelButton: true,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#FFCA28",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          let model = {
            LicenseId: row.LicenseId,
            LicenseDetailId: row.LicenseDetailId,
            UpdatedBy: Number(localStorage.getItem("userid")),
          };
          this.appLoader.open();
          this.licenseService
            .deleteParticularCustomerParticularLicense(model)
            .subscribe((data) => {
              if (!data.IsError && data.DataObject != null) {
                this.originalScal360LicenseList = data.DataObject;
                this.scal360LicenseList = [...this.originalScal360LicenseList];
                this.expandedRow = null;
                this.setPage(this.pager.currentPage);
                this.appLoader.close();
              } else {
                this.appLoader.close();
                Swal.fire({
                  title: "Error",
                  text: data.Error,
                  showConfirmButton: true,
                  confirmButtonColor: "#FFCA28",
                });
                return;
              }
            });
        }
      });
    }
  }


    setPage(page: number) {
        this.scal360LicenseList = [...this.originalScal360LicenseList];
        this.applySort();
        this.filteredScal360LicenseList = this.filterPipe.transform(this.scal360LicenseList, this.filterSCALType, this.filterBillToName, this.filterShipToName, this.filterLicenseKey)
        this.pager = this.pagerService.getPager(this.filteredScal360LicenseList.length, page);
        this.pagedItems = this.filteredScal360LicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage = (this.pagedItems.length == 0) ? "No records found." : "";
    }

    exportToCSV() {
        let jsonData: Array<any> = [];
        if (this.scal360LicenseList) {
            this.scal360LicenseList.forEach(element => {
                jsonData.push({
                    BillToName: element.BillToName,
                    BillToAddress1: element.BillToAddress1,
                    BillToAddress2: element.BillToAddress2,
                    BillToCity: element.BillToCity,
                    BillToState: element.BillToState,
                    BillToZipcode: element.BillToZipcode,
                    BillToCountryCode: element.BillToCountryCode,
                    ShipToName: element.ShipToName,
                    ShipToAddress1: element.ShipToAddress1,
                    ShipToAddress2: element.ShipToAddress2,
                    ShipToCity: element.ShipToCity,
                    ShipToState: element.ShipToState,
                    ShipToZipcode: element.ShipToZipcode,
                    ShipToCountryCode: element.ShipToCountryCode,
                    LicenseType: element.LicenseType,
                    ScalType:element.SCALType,
                    LicensePurchased: element.NoOfLicensePurchased,
                    LicenseActivated: element.TotalNoOfLicenseActivated
                })
            });
            this.exportService.exportToCsv(jsonData, 'SCAL360')
        }
        else {
            Swal.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            })
        }
    }
    clearSearch() {
        this.searchBillToName = this.filterBillToName = '';
        this.searchShipToName = this.filterShipToName = '';
        this.searchLicenseKey = this.filterLicenseKey = '';
        this.searchSCALType = this.filterSCALType = '';
        this.expandedRow = null;
        this.setPage(1);
        // this.getBillingShippingDetail('SO-0002995');
    }
    search() {
        this.filterBillToName = this.searchBillToName;
        this.filterShipToName = this.searchShipToName;
        this.filterLicenseKey = this.searchLicenseKey;
        this.filterSCALType = this.searchSCALType ? SCALType[this.searchSCALType] : '';
        this.expandedRow = null
        this.setPage(1);
        // console.log(this.filterBillToName,this.filterShipToName,this.filterLicenseKey,this.filterSCALType)
    }
    getScalPurchaseLicenseDisplayDetails() {
        this.appLoader.open();
        this.licenseService.getScalPurchaseLicenseDisplayDetails().subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
                this.originalScal360LicenseList = data.DataObject;
                this.scal360LicenseList = [...this.originalScal360LicenseList];
                this.setPage(1);
                this.buildSearchArray();
            }
            else {

            }
            this.appLoader.close();
        });
    }
    buildSearchArray() {
        const BillToArray = this.scal360LicenseList.map(item => item.BillToName)
        const ShipToArray = this.scal360LicenseList.map(item => item.ShipToName)
        this.BillToList = Array.from(new Set(BillToArray)).sort();
        this.ShipToList = Array.from(new Set(ShipToArray)).sort();
    }
    onSortChange(event){
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
        
    }
    applySort(){
        if(!this.currentSortColumn || !this.currentSortOrder) return;
        this.scal360LicenseList=this.scal360LicenseList.sort((a,b)=>
            {
                if(this.currentSortOrder==='asc'){
                    a[this.currentSortColumn]=a[this.currentSortColumn] || '';
                    return a[this.currentSortColumn].localeCompare(b[this.currentSortColumn])
                }
                else if (this.currentSortOrder==='desc'){
                    b[this.currentSortColumn]=b[this.currentSortColumn] || '';
                    return b[this.currentSortColumn].localeCompare(a[this.currentSortColumn])
                }
                else {
                    return 0;
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/scal360.component.ts